export default function SQLs_Order_By() {
  return (
    <div>
      <h1>SQL Primary Key</h1>
      <p>Content for SQL Primary Key will go here.</p>
    </div>
  );
}
